import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loadingDoctorInfo: false,
  success: '',
  doctorInfoError: '',
  specialitiesError: '',
  doctorListError: '',
  communitiesError: '',
  doctorList: [],
  specialities: [],
  communities: [],
  doctorInfo: {},
  hasNext: false,
  page: 0,
  hasPrev: false,
  total_pages: 0,
  total_result: 0,
  loadingSpecialites: false,
  loadingDoctorList: false,
  loadingCommunity: false,
  loading: false,
}

const doctorSlice = createSlice({
  name: 'doctorSlice',
  initialState: initialState,
  reducers: {
    getSpecialities: () => {},
    getDoctorList: () => {},
    getDoctorInfo: () => {},
    getCommunities: () => {},
    setSpecialities: (state, action) => {
      return {
        ...state,
        loadingSpecialites: false,
        specialities: action.payload,
        error: '',
      }
    },
    setDoctorList: (state, action) => {
      return {
        ...state,
        loadingDoctorList: false,
        doctorList: action.payload.data,
        hasNext: action.payload.hasNext,
        hasPrev: action.payload.hasPrev,
        total_pages: action.payload.total_pages,
        total_result: action.payload.total_result,
        page: action.payload.page,
        error: '',
      }
    },
    setDoctorInfo: (state, action) => {
      return {
        ...state,
        loadingDoctorInfo: false,
        loading: false,
        doctorInfo: action.payload,
        error: '',
      }
    },
    setCommunitiesInfo: (state, action) => {
      return {
        ...state,
        loadingCommunity: false,
        communities: action.payload,
        error: '',
      }
    },
    updateCommunitiesInfo: (state, action) => {
      return {
        ...state,
        loading: false,
        doctorInfo: {
          ...state.doctorInfo,
          doctor_profile: {
            ...state.doctorInfo.doctor_profile,
            communities: [
              ...state.doctorInfo.doctor_profile.communities,
              action.payload,
            ],
          },
        },
        error: '',
      }
    },
    updateDoctorSpecialities: (state, action) => {
      return {
        ...state,
        loading: false,
        doctorInfo: {
          ...state.doctorInfo,
          doctor_profile: {
            ...state.doctorInfo.doctor_profile,
            specialization: [
              ...state.doctorInfo.doctor_profile.specialization,
              ...action.payload,
            ],
          },
        },
      }
    },
    addExperiences: () => {},
    addEducations: () => {},
    deleteExperience: () => {},
    deleteEducation: () => {},
    editDoctorProfile: () => {},
    editSpecialization: () => {},
    editExperience: () => {},
    editEducation: () => {},
    editCommunities: () => {},
    deleteCommunity: () => {},
    deleteSpeciality: () => {},
    updateExperience: () => {},
    updateEducation: () => {},
    verifyNmc: () => {},
    updateNmcState: (state, action) => {
      if (action?.payload?.index === undefined) {
        return {
          ...state,
          loading: false,
          doctorInfo: {
            ...state.doctorInfo,
            status: 'NMC_VERIFIED',
          },
        }
      } else {
        return {
          ...state,
          loading: false,
          doctorList: [...state.doctorList].map((doctor, index) => {
            if (index === action.payload.index) {
              return { ...doctor, status: 'NMC_VERIFIED' }
            } else {
              return doctor
            }
          }),
        }
      }
    },

    removeCommunityFromState: (state, action) => {
      return {
        ...state,
        loading: false,
        doctorInfo: {
          ...state.doctorInfo,
          doctor_profile: {
            ...state.doctorInfo.doctor_profile,
            communities: [
              ...state.doctorInfo.doctor_profile.communities,
            ].filter((community) => community.id !== action.payload),
          },
        },
      }
    },

    removeSpecialityFromState: (state, action) => {
      return {
        ...state,
        loading: false,
        doctorInfo: {
          ...state.doctorInfo,
          doctor_profile: {
            ...state.doctorInfo.doctor_profile,
            specialization: [
              ...state.doctorInfo.doctor_profile.specialization,
            ].filter((speciality) => speciality.id !== action.payload),
          },
        },
      }
    },

    addExperiencesToState: (state, action) => {
      return {
        ...state,
        loading: false,
        doctorInfo: {
          ...state.doctorInfo,
          doctor_profile: {
            ...state.doctorInfo.doctor_profile,
            experience: [
              ...state.doctorInfo.doctor_profile.experience,
              ...action.payload,
            ],
          },
        },
      }
    },

    addEducationToState: (state, action) => {
      return {
        ...state,
        loading: false,
        doctorInfo: {
          ...state.doctorInfo,
          doctor_profile: {
            ...state.doctorInfo.doctor_profile,
            education: [
              ...state.doctorInfo.doctor_profile.education,
              ...action.payload,
            ],
          },
        },
      }
    },

    removeEducationFromState: (state, action) => {
      return {
        ...state,
        loading: false,
        doctorInfo: {
          ...state.doctorInfo,
          doctor_profile: {
            ...state.doctorInfo.doctor_profile,
            education: [...state.doctorInfo.doctor_profile.education].filter(
              (education) => education.id !== action.payload,
            ),
          },
        },
      }
    },

    removeExperienceFromState: (state, action) => {
      return {
        ...state,
        loading: false,
        doctorInfo: {
          ...state.doctorInfo,
          doctor_profile: {
            ...state.doctorInfo.doctor_profile,
            experience: [...state.doctorInfo.doctor_profile.experience].filter(
              (experience) => experience.id !== action.payload,
            ),
          },
        },
      }
    },

    updateEducationToState: (state, action) => {
      return {
        ...state,
        loading: false,
        doctorInfo: {
          ...state.doctorInfo,
          doctor_profile: {
            ...state.doctorInfo.doctor_profile,
            education: [...state.doctorInfo.doctor_profile.education].map(
              (education) => {
                if (education.id === action.payload[0].id) {
                  return action.payload[0]
                }
                return education
              },
            ),
          },
        },
      }
    },

    updateExperienceToState: (state, action) => {
      return {
        ...state,
        loading: false,
        doctorInfo: {
          ...state.doctorInfo,
          doctor_profile: {
            ...state.doctorInfo.doctor_profile,
            experience: state.doctorInfo.doctor_profile.experience.map(
              (experience) => {
                if (experience.id === action.payload[0].id) {
                  return action.payload[0]
                }
                return experience
              },
            ),
          },
        },
      }
    },

    updatePageNumber: () => {},

    setLoading: (state, action) => {
      if (action.payload.type === 'specialization') {
        state.loadingSpecialites = true
        state.specialitiesError = ''
      } else if (action.payload.type === 'doctor') {
        state.loadingDoctorList = true
        state.doctorListError = ''
      } else if (action.payload.type === 'community') {
        state.loadingCommunity = true
        state.communitiesError = ''
      } else if (action.payload.type === 'info') {
        state.loadingDoctorInfo = true
        state.doctorInfoError = ''
      } else {
        state.loading = true
      }
    },

    setError: (state, action) => {
      if (action.payload.type === 'specialization') {
        state.specialitiesError = action.payload.error
        state.loadingSpecialites = false
      } else if (action.payload.type === 'doctor') {
        state.doctorListError = action.payload.error
        state.loadingDoctorList = false
      } else if (action.payload.type === 'community') {
        state.communitiesError = action.payload.error
        state.loadingCommunity = false
      } else if (action.payload.type === 'info') {
        state.doctorInfoError = action.payload.error
        state.loadingDoctorInfo = false
      }
      state.loading = false
    },
  },
})

export const {
  setLoading,
  setError,
  getSpecialities,
  getDoctorList,
  getDoctorInfo,
  getCommunities,
  setSpecialities,
  setDoctorList,
  setDoctorInfo,
  setCommunitiesInfo,
  editEducation,
  editExperience,
  editCommunities,
  editSpecialization,
  editDoctorProfile,
  updateCommunitiesInfo,
  updateDoctorSpecialities,
  removeSpecialityFromState,
  removeCommunityFromState,
  deleteCommunity,
  deleteSpeciality,
  addExperiences,
  addEducations,
  deleteEducation,
  deleteExperience,
  addEducationToState,
  addExperiencesToState,
  removeExperienceFromState,
  removeEducationFromState,
  updateEducationToState,
  updateExperienceToState,
  updateEducation,
  updateExperience,
  updatePageNumber,
  updateNmcState,
  verifyNmc,
} = doctorSlice.actions

export default doctorSlice.reducer
